import styled from 'styled-components';
import Icon from '../../Atoms/SocialIcons/Icon/Icon';
import spacing from '../../../theme/shared/spacing';
import EmailSignUp from '../../Organisms/EmailSignUp/EmailSignUp';
var IconWrapper = styled.div.withConfig({
  displayName: "HeaderEsuWithIconstyle__IconWrapper",
  componentId: "sc-1a84kwt-0"
})(["width:35px;height:35px;display:inline-block;"]);
var EsuWrapper = styled.div.withConfig({
  displayName: "HeaderEsuWithIconstyle__EsuWrapper",
  componentId: "sc-1a84kwt-1"
})(["position:fixed;width:100%;height:100%;background-color:rgba(255,255,255,0.5);z-index:100;top:0;left:0;overflow-y:auto;display:flex;justify-content:center;align-items:flex-start;div[aria-modal='true']{padding:", ";}"], spacing('l'));
var CloseButton = styled(Icon).withConfig({
  displayName: "HeaderEsuWithIconstyle__CloseButton",
  componentId: "sc-1a84kwt-2"
})(["position:absolute;top:0;right:0;width:40px;height:40px;margin-left:0;@media ", "{margin:", " 0 0;right:25%;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoint('small');
}, spacing('xl'));
var HeaderESU = styled(EmailSignUp).withConfig({
  displayName: "HeaderEsuWithIconstyle__HeaderESU",
  componentId: "sc-1a84kwt-3"
})(["width:100%;input{font-size:", ";}@media ", "{margin-top:", ";width:50%;input{font-size:", ";}}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSize('s');
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoint('small');
}, spacing('xl'), function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSize('m');
});
export { IconWrapper, EsuWrapper, CloseButton, HeaderESU };